import { Dedication } from 'models/Dedication'

const buildOrdersDedicationObject = (dedication: Dedication) => {
  const {
    type,
    honoreeFirstName,
    honoreeLastName,
    recipientFirstName,
    recipientLastName,
    recipientEmailAddress: recipientEmail,
    recipientAddress: recipientAddress1,
    recipientCity,
    recipientState,
    recipientPostalCode,
    recipientCountry,
    ecardMessage,
    selectedEcardId: ecardId,
  } = dedication

  const ordersDedication = {
    type,
    honoreeFirstName,
    honoreeLastName,
    ...(recipientEmail ? { recipientEmail } : {}),
    ...(recipientFirstName ? { recipientFirstName } : {}),
    ...(recipientLastName ? { recipientLastName } : {}),
    ...(recipientAddress1 ? { recipientAddress1 } : {}),
    ...(recipientCity ? { recipientCity } : {}),
    ...(recipientState ? { recipientState } : {}),
    ...(recipientPostalCode ? { recipientPostalCode } : {}),
    ...(recipientCountry ? { recipientCountry } : {}),
    ...(ecardMessage ? { ecardMessage } : {}),
    ...(ecardId ? { ecardId } : {}),
  }

  return ordersDedication
}

export default buildOrdersDedicationObject
